import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import { useTranslation } from "react-i18next";
import JSONSchemaForm from "@rjsf/bootstrap-4";
import { MouseEventHandler, useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import LeagueSelector from "@main/leagues/components/LeagueSelector";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => MouseEventHandler;
  backendFormErrors: any;
}

function CategoryForm(props: Prop) {
  const { formRef, onSubmit, context } = props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});

  const translations = {
    code: t("code"),
    name: t("name"),
    league_id: t("league_id"),
    days: t("days"),
  };

  let schema: RJSFSchema = {
    type: "object",
    // required: ['minutes', 'customer_id', 'task', 'date', 'report_id'],
    properties: {
      code: {
        type: "string",
        title: translations.code,
      },
      name: {
        type: "string",
        title: translations.name,
      },
      start_date: {
        type: "string",
        format: "date",
        title: t("start_date"),
      },
      two_rounds: {
        type: "boolean",
        title: t("two_rounds"),
        default: false,
      },
      days: {
        type: "array",
        title: t("days"),
        uniqueItems: true,
        items: {
          type: "object",
          properties: {
            day: {
              type: "string",
              title: t("day"),
              enum: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
            },
            games: {
              type: "array",
              title: t("games"),
              uniqueItems: true,
              items: {
                type: "object",
                properties: {
                  start_hour: {
                    type: "string",
                    title: t("start_hour"),
                  },
                },
              },
            },            
          },          
        },
      }
    },
  };
  const uiSchema: UiSchema = {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    league_id: {
      "ui:widget": "league-selector",
    }
  };
  const customWidgets = {
    ...{
      "league-selector": LeagueSelector
    },
    ...widgets,
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  return (
    <JSONSchemaForm
      noHtml5Validate
      showErrorList={false}
      ref={formRef}
      schema={schema}
      uiSchema={uiSchema}
      widgets={customWidgets}
      formData={element}
      validator={validator}
      onChange={handleChange}
      onSubmit={onSubmit}
      onError={log("errors")}
      extraErrors={backendFormErrors}
    />
  );
}

export default CategoryForm;
